import { render, staticRenderFns } from "./RegistryRequestSideBar.vue?vue&type=template&id=66803990&"
import script from "./RegistryRequestSideBar.vue?vue&type=script&lang=js&"
export * from "./RegistryRequestSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports